// extracted by mini-css-extract-plugin
export default {"loading":"GraphLoader_loading__Ruti9","loadingWrapper":"GraphLoader_loadingWrapper__HueNZ"};